// import {
//   useCallback,
//   useEffect,
//   useLayoutEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { createPortal } from "react-dom";
// import { FaSearch } from "react-icons/fa";
// import { useLocation, useNavigate } from "react-router-dom";
// import { SEARCH_DATA } from "../data/searchData";
// import "./SiteSearch.css";

// const normalize = (value = "") =>
//   String(value)
//     .toLocaleLowerCase()
//     .normalize("NFD")
//     .replace(/[\u0300-\u036f]/g, "")
//     .replace(/[^\p{L}\p{N}\s]/gu, " ")
//     .replace(/\s+/g, " ")
//     .trim();

// const scorePage = (page, rawQuery) => {
//   const query = normalize(rawQuery);
//   if (query.length < 2) return 0;

//   const title = normalize(page.title);
//   const keywords = normalize(
//     Array.isArray(page.keywords) ? page.keywords.join(" ") : page.keywords
//   );
//   const content = normalize(page.content);
//   const searchableText = `${title} ${keywords} ${content}`;
//   const terms = query.split(" ").filter(Boolean);

//   if (!terms.every((term) => searchableText.includes(term))) return 0;

//   let score = 0;

//   if (title === query) score += 250;
//   else if (title.startsWith(query)) score += 150;
//   else if (title.includes(query)) score += 100;

//   if (keywords.includes(query)) score += 70;
//   if (content.includes(query)) score += 35;

//   terms.forEach((term) => {
//     if (title.startsWith(term)) score += 30;
//     else if (title.includes(term)) score += 20;
//     if (keywords.includes(term)) score += 12;
//     if (content.includes(term)) score += 5;
//   });

//   return score;
// };

// const getSnippet = (content = "", query = "") => {
//   const plainText = String(content).replace(/\s+/g, " ").trim();
//   if (!plainText) return "Open this page";

//   const firstTerm = normalize(query).split(" ")[0];
//   const normalizedContent = normalize(plainText);
//   const foundAt = firstTerm ? normalizedContent.indexOf(firstTerm) : -1;
//   const start = Math.max(0, foundAt > -1 ? foundAt - 55 : 0);
//   const end = Math.min(plainText.length, start + 145);

//   return `${start > 0 ? "…" : ""}${plainText.slice(start, end)}${
//     end < plainText.length ? "…" : ""
//   }`;
// };

// const isPdf = (url = "") => /\.pdf(?:$|[?#])/i.test(url);
// const isExternal = (url = "") => /^(?:https?:)?\/\//i.test(url);

// export default function SiteSearch({ onNavigate }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const searchRef = useRef(null);
//   const resultsRef = useRef(null);
//   const [query, setQuery] = useState("");
//   const [isOpen, setIsOpen] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(-1);
//   const [panelStyle, setPanelStyle] = useState({});

//   const results = useMemo(() => {
//     const cleanQuery = query.trim();
//     if (cleanQuery.length < 2) return [];

//     return SEARCH_DATA.map((page) => ({
//       ...page,
//       score: scorePage(page, cleanQuery),
//     }))
//       .filter((page) => page.score > 0)
//       .sort((a, b) => b.score - a.score || a.title.localeCompare(b.title))
//       .slice(0, 8);
//   }, [query]);

//   const shouldShowPanel = isOpen && query.trim().length >= 2;

//   const updatePanelPosition = useCallback(() => {
//     if (!searchRef.current) return;

//     const rect = searchRef.current.getBoundingClientRect();
//     const viewportPadding = 12;
//     const left = Math.max(viewportPadding, rect.left);
//     const availableWidth = window.innerWidth - left - viewportPadding;

//     setPanelStyle({
//       top: Math.round(rect.bottom + 8),
//       left: Math.round(left),
//       width: Math.max(220, Math.min(rect.width, availableWidth)),
//       maxHeight: Math.max(180, window.innerHeight - rect.bottom - 24),
//     });
//   }, []);

//   useEffect(() => {
//     const closeOnOutsideClick = (event) => {
//       const clickedSearch = searchRef.current?.contains(event.target);
//       const clickedResults = resultsRef.current?.contains(event.target);

//       if (!clickedSearch && !clickedResults) {
//         setIsOpen(false);
//         setActiveIndex(-1);
//       }
//     };

//     document.addEventListener("mousedown", closeOnOutsideClick);
//     return () => document.removeEventListener("mousedown", closeOnOutsideClick);
//   }, []);

//   useEffect(() => {
//     setIsOpen(false);
//     setActiveIndex(-1);
//     setQuery("");
//   }, [location.pathname, location.search]);

//   useEffect(() => {
//     setActiveIndex(-1);
//   }, [query]);

//   useLayoutEffect(() => {
//     if (!shouldShowPanel) return undefined;

//     updatePanelPosition();
//     window.addEventListener("resize", updatePanelPosition);
//     window.addEventListener("scroll", updatePanelPosition, true);

//     return () => {
//       window.removeEventListener("resize", updatePanelPosition);
//       window.removeEventListener("scroll", updatePanelPosition, true);
//     };
//   }, [shouldShowPanel, updatePanelPosition]);

//   const openResult = (page) => {
//     const url = page?.path || page?.href;
//     if (!url || url === "#") return;

//     setIsOpen(false);
//     setActiveIndex(-1);
//     onNavigate?.();

//     if (isPdf(url)) {
//       window.open(url, "_blank", "noopener,noreferrer");
//       return;
//     }

//     if (isExternal(url)) {
//       window.location.assign(url);
//       return;
//     }

//     navigate(url);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     const selectedResult = results[activeIndex] || results[0];
//     if (selectedResult) openResult(selectedResult);
//   };

//   const handleKeyDown = (event) => {
//     if (event.key === "Escape") {
//       setIsOpen(false);
//       setActiveIndex(-1);
//       return;
//     }

//     if (!shouldShowPanel || results.length === 0) return;

//     if (event.key === "ArrowDown") {
//       event.preventDefault();
//       setActiveIndex((current) => (current + 1) % results.length);
//     } else if (event.key === "ArrowUp") {
//       event.preventDefault();
//       setActiveIndex((current) =>
//         current <= 0 ? results.length - 1 : current - 1
//       );
//     } else if (event.key === "Enter" && activeIndex >= 0) {
//       event.preventDefault();
//       openResult(results[activeIndex]);
//     }
//   };

//   const resultPanel = shouldShowPanel ? (
//     <div
//       ref={resultsRef}
//       id="site-search-results"
//       className="search-results"
//       role="listbox"
//       aria-label="Search results"
//       style={panelStyle}
//     >
//       {results.length > 0 ? (
//         results.map((page, index) => (
//           <button
//             key={`${page.path}-${page.title}`}
//             type="button"
//             role="option"
//             aria-selected={index === activeIndex}
//             className={`search-result ${
//               index === activeIndex ? "search-result-active" : ""
//             }`}
//             onMouseEnter={() => setActiveIndex(index)}
//             onMouseDown={(event) => event.preventDefault()}
//             onClick={() => openResult(page)}
//           >
//             <span className="search-result-copy">
//               <strong>{page.title}</strong>
//               <small>{getSnippet(page.content, query)}</small>
//             </span>
//             <span className="search-result-path">{page.path}</span>
//           </button>
//         ))
//       ) : (
//         <div className="search-empty">
//           No page found for “{query.trim()}”
//         </div>
//       )}
//     </div>
//   ) : null;

//   return (
//     <>
//       {/* Existing class names are unchanged, so old Navbar.css styling remains. */}
//       <form
//         ref={searchRef}
//         className="search-bar site-search"
//         role="search"
//         onSubmit={handleSubmit}
//       >
//         <label className="site-search-sr-only" htmlFor="site-search-input">
//           Search the website
//         </label>
//         <input
//           id="site-search-input"
//           className="search-input"
//           type="search"
//           autoComplete="off"
//           placeholder="Search ASSOCHAM..."
//           value={query}
//           aria-autocomplete="list"
//           aria-controls="site-search-results"
//           aria-expanded={shouldShowPanel}
//           onFocus={() => setIsOpen(true)}
//           onChange={(event) => {
//             setQuery(event.target.value);
//             setIsOpen(true);
//           }}
//           onKeyDown={handleKeyDown}
//         />
//         <button
//           className="search-icon-btn"
//           type="submit"
//           aria-label="Search"
//         >
//           <FaSearch size={18} />
//         </button>
//       </form>

//       {typeof document !== "undefined" && resultPanel
//         ? createPortal(resultPanel, document.body)
//         : null}
//     </>
//   );
// }





// new new code 




import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { createPortal } from "react-dom";
import { FaSearch } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CATEGORY_ORDER,
  STATIC_PAGES,
  loadRemoteSearchPages,
} from "../data/searchData";
import { normalize } from "../utils/searchText";
import "./SiteSearch.css";

const MAX_RESULTS = 12;

// Pages are pre-indexed in searchData.js, so scoring only compares strings.
const scorePage = (page, query, terms) => {
  if (!terms.every((term) => page._all.includes(term))) return 0;

  const title = page._title;
  const keywords = page._keywords;
  const content = page._content;
  let score = 1;

  if (title === query) score += 250;
  else if (title.startsWith(query)) score += 150;
  else if (title.includes(query)) score += 100;

  if (keywords.includes(query)) score += 70;
  if (content.includes(query)) score += 35;

  terms.forEach((term) => {
    if (title.startsWith(term)) score += 30;
    else if (title.includes(term)) score += 20;
    if (keywords.includes(term)) score += 12;
    if (content.includes(term)) score += 5;
  });

  return score;
};

const getSnippet = (content = "", query = "") => {
  const plainText = String(content).replace(/\s+/g, " ").trim();
  if (!plainText) return "Open this page";

  const firstTerm = normalize(query).split(" ")[0];
  const foundAt = firstTerm
    ? plainText.toLocaleLowerCase().indexOf(firstTerm)
    : -1;
  const start = Math.max(0, foundAt > -1 ? foundAt - 55 : 0);
  const end = Math.min(plainText.length, start + 145);

  return `${start > 0 ? "…" : ""}${plainText.slice(start, end)}${
    end < plainText.length ? "…" : ""
  }`;
};

const isPdf = (url = "") => /\.pdf(?:$|[?#])/i.test(url);
const isExternal = (url = "") => /^(?:https?:)?\/\//i.test(url);
const displayPath = (url = "") =>
  url.replace(/^https?:\/\//i, "").split("?")[0];

export default function SiteSearch({ onNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchRef = useRef(null);
  const panelRef = useRef(null);
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [panelStyle, setPanelStyle] = useState({});
  const [category, setCategory] = useState("All");
  const [remotePages, setRemotePages] = useState([]);
  const [isLoadingRemote, setIsLoadingRemote] = useState(false);

  // Static pages + data loaded from the backend (events, news...).
  const allPages = useMemo(
    () => (remotePages.length ? [...STATIC_PAGES, ...remotePages] : STATIC_PAGES),
    [remotePages]
  );

  const scored = useMemo(() => {
    const normalizedQuery = normalize(query);
    if (normalizedQuery.length < 2) return [];

    const terms = normalizedQuery.split(" ").filter(Boolean);

    return allPages
      .map((page) => ({ ...page, score: scorePage(page, normalizedQuery, terms) }))
      .filter((page) => page.score > 0)
      .sort((a, b) => b.score - a.score || a.title.localeCompare(b.title));
  }, [query, allPages]);

  // Result count per section, used for the filter chips.
  const categoryCounts = useMemo(() => {
    const counts = {};
    scored.forEach((page) => {
      counts[page.category] = (counts[page.category] || 0) + 1;
    });
    return counts;
  }, [scored]);

  const categories = useMemo(() => {
    const known = CATEGORY_ORDER.filter((name) => categoryCounts[name]);
    const extra = Object.keys(categoryCounts).filter(
      (name) => !CATEGORY_ORDER.includes(name)
    );
    return [...known, ...extra];
  }, [categoryCounts]);

  // If the chosen section has no matches for a new query, fall back to All.
  const activeCategory =
    category === "All" || categoryCounts[category] ? category : "All";

  const results = useMemo(
    () =>
      (activeCategory === "All"
        ? scored
        : scored.filter((page) => page.category === activeCategory)
      ).slice(0, MAX_RESULTS),
    [scored, activeCategory]
  );

  const shouldShowPanel = isOpen && normalize(query).length >= 2;

  const updatePanelPosition = useCallback(() => {
    if (!searchRef.current) return;

    const rect = searchRef.current.getBoundingClientRect();
    const viewportPadding = 12;
    const left = Math.max(viewportPadding, rect.left);
    const availableWidth = window.innerWidth - left - viewportPadding;

    setPanelStyle({
      top: Math.round(rect.bottom + 8),
      left: Math.round(left),
      width: Math.max(220, Math.min(rect.width, availableWidth)),
      maxHeight: Math.max(180, window.innerHeight - rect.bottom - 24),
    });
  }, []);

  // Load backend data the first time the search opens (cached afterwards).
  useEffect(() => {
    if (!isOpen) return undefined;

    let cancelled = false;
    setIsLoadingRemote(true);

    loadRemoteSearchPages()
      .then((pages) => {
        if (!cancelled) setRemotePages(pages);
      })
      .finally(() => {
        if (!cancelled) setIsLoadingRemote(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      const clickedSearch = searchRef.current?.contains(event.target);
      const clickedPanel = panelRef.current?.contains(event.target);

      if (!clickedSearch && !clickedPanel) {
        setIsOpen(false);
        setActiveIndex(-1);
      }
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveIndex(-1);
    setQuery("");
    setCategory("All");
  }, [location.pathname, location.search]);

  useEffect(() => {
    setActiveIndex(-1);
  }, [query, activeCategory]);

  useLayoutEffect(() => {
    if (!shouldShowPanel) return undefined;

    updatePanelPosition();
    window.addEventListener("resize", updatePanelPosition);
    window.addEventListener("scroll", updatePanelPosition, true);

    return () => {
      window.removeEventListener("resize", updatePanelPosition);
      window.removeEventListener("scroll", updatePanelPosition, true);
    };
  }, [shouldShowPanel, updatePanelPosition]);

  // Keep the keyboard-selected result visible inside the scrollable list.
  useEffect(() => {
    if (activeIndex < 0) return;
    panelRef.current
      ?.querySelector('[aria-selected="true"]')
      ?.scrollIntoView({ block: "nearest" });
  }, [activeIndex]);

  const openResult = (page) => {
    const url = page?.path || page?.href;
    if (!url || url === "#") return;

    setIsOpen(false);
    setActiveIndex(-1);
    onNavigate?.();

    if (isPdf(url) || isExternal(url)) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    navigate(url);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const selectedResult = results[activeIndex] || results[0];
    if (selectedResult) openResult(selectedResult);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setIsOpen(false);
      setActiveIndex(-1);
      return;
    }

    if (!shouldShowPanel || results.length === 0) return;

    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActiveIndex((current) => (current + 1) % results.length);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setActiveIndex((current) =>
        current <= 0 ? results.length - 1 : current - 1
      );
    } else if (event.key === "Enter" && activeIndex >= 0) {
      event.preventDefault();
      openResult(results[activeIndex]);
    }
  };

  const resultPanel = shouldShowPanel ? (
    <div
      ref={panelRef}
      id="site-search-panel"
      className="search-results"
      style={panelStyle}
    >
      {categories.length > 1 && (
        <div
          className="search-filters"
          role="group"
          aria-label="Filter results by section"
        >
          {["All", ...categories].map((name) => (
            <button
              key={name}
              type="button"
              aria-pressed={activeCategory === name}
              className={`search-filter-chip ${
                activeCategory === name ? "search-filter-chip-active" : ""
              }`}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => setCategory(name)}
            >
              {name}
              <span className="search-filter-count">
                {name === "All" ? scored.length : categoryCounts[name]}
              </span>
            </button>
          ))}
        </div>
      )}

      <div
        id="site-search-results"
        className="search-results-list"
        role="listbox"
        aria-label="Search results"
      >
        {results.length > 0 ? (
          results.map((page, index) => (
            <button
              key={page.id}
              type="button"
              role="option"
              aria-selected={index === activeIndex}
              className={`search-result ${
                index === activeIndex ? "search-result-active" : ""
              }`}
              onMouseEnter={() => setActiveIndex(index)}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => openResult(page)}
            >
              <span className="search-result-copy">
                <strong>{page.title}</strong>
                <small>{getSnippet(page.content, query)}</small>
              </span>
              <span className="search-result-meta">
                <em className="search-result-badge">{page.category}</em>
                <span className="search-result-path">{displayPath(page.path)}</span>
              </span>
            </button>
          ))
        ) : (
          <div className="search-empty">
            {isLoadingRemote
              ? "Searching…"
              : `No page found for “${query.trim()}”`}
          </div>
        )}
      </div>

      {isLoadingRemote && results.length > 0 && (
        <div className="search-loading">Loading events &amp; news…</div>
      )}
    </div>
  ) : null;

  return (
    <>
      {/* Existing class names are unchanged, so old Navbar.css styling remains. */}
      <form
        ref={searchRef}
        className="search-bar site-search"
        role="search"
        onSubmit={handleSubmit}
      >
        <label className="site-search-sr-only" htmlFor="site-search-input">
          Search the website
        </label>
        <input
          id="site-search-input"
          className="search-input"
          type="search"
          autoComplete="off"
          placeholder="Search ASSOCHAM..."
          value={query}
          aria-autocomplete="list"
          aria-controls="site-search-results"
          aria-expanded={shouldShowPanel}
          onFocus={() => setIsOpen(true)}
          onChange={(event) => {
            setQuery(event.target.value);
            setIsOpen(true);
          }}
          onKeyDown={handleKeyDown}
        />
        <button className="search-icon-btn" type="submit" aria-label="Search">
          <FaSearch size={18} />
        </button>
      </form>

      {typeof document !== "undefined" && resultPanel
        ? createPortal(resultPanel, document.body)
        : null}
    </>
  );
}